var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #5d5467; /* small border on top left petal */\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #5d5467; /* top left petal and begin of text */\n      }\n\n      .cls-3 {\n        fill: #931ffa; /* three petals */\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 284.58,
    cy: 235.043,
    r: 70.033,
    transform: "translate(7.212 450.346) rotate(-75.239)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 122.329,
    cy: 235.043,
    r: 70.033,
    transform: "translate(-112.999 298.225) rotate(-76.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.208.5h71.813c39.635,0,71.813,32.178,71.813,71.813h0c0,39.635-32.178,71.813-71.813,71.813h0c-39.635,0-71.813-32.178-71.813-71.813V.5h0Z",
    transform: "translate(266.042 144.626) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 285.923,
    cy: 74.043,
    r: 70.033,
    transform: "translate(168.27 334.296) rotate(-76.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.73,367.052l23.854,43.274h-19.798l-15.579-27.642-8.276,11.252v16.39H0v-75.729h18.933v33.646l23.854-33.646h19.798l-23.854,32.455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m68.161,333.515c0-5.68,4.706-10.331,10.44-10.331,5.625,0,10.277,4.651,10.277,10.331,0,5.734-4.652,10.386-10.277,10.386-5.734,0-10.44-4.651-10.44-10.386Zm19.257,17.31v59.502h-17.742v-59.502h17.742Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m150.057,365.051l-29.967,30.671h29.967v14.604h-52.578v-14.604l29.534-30.671h-29.534v-14.226h52.578v14.226Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m266.142,350.824l-18.283,59.502h-24.774l-11.359-37.378-11.413,37.378h-24.721l-18.283-59.502h18.933l12.333,43.112,13.469-43.112h19.311l13.523,43.112,12.333-43.112h18.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m267.446,380.575c0-19.311,15.092-30.67,32.618-30.67,17.418,0,32.618,11.359,32.618,30.67s-15.2,30.671-32.618,30.671c-17.526,0-32.618-11.359-32.618-30.671Zm47.493,0c0-9.412-6.707-15.687-14.875-15.687s-14.875,6.274-14.875,15.687,6.707,15.686,14.875,15.686,14.875-6.274,14.875-15.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m357.893,350.824l.81,7.032c4.166-5.842,10.17-7.951,19.636-7.951v15.037c-13.252,0-19.636,6.112-19.636,15.633v29.751h-17.742v-59.502h16.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m425.456,375.49l22.448,34.836h-19.474l-14.226-22.503-7.682,8.439v14.064h-17.742v-81.139h17.742v45.222l21.15-23.585h20.23l-22.448,24.666Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ac972f800a35925765ffdb8bf046990.svg";
export { ForwardRef as ReactComponent };